import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';

export class RF_StockOnHand extends Component {
    static displayName = RF_StockOnHand.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            loading: true,
            namecode: "",
            productCode: "",
            soh: [],
        }
    }
    componentDidMount() {
    
        if (MyGlobal.rf_transfer) {
            var rf_transfersettings = JSON.parse(MyGlobal.rf_transfer);
            if (rf_transfersettings) {
                this.state.namecode = rf_transfersettings.namecode;
            }
        }
        if (this.props.location && this.props.location.state) {
           
            if (this.props.location.state.selectedProductCode) {
                this.state.productCode = this.props.location.state.selectedProductCode;
            }
        }
        this.loadStockOnHand();
    }
    goto(page) {
        this.history.push(page);
    }
    async loadStockOnHand() {
        if (this.state.namecode == "") {
            this.setState({ alertMessage: "Namecode not populated. Please make sure you have selected the correct product" });
            return;
        }
        if (this.state.productCode == "") {
            this.setState({ alertMessage: "ProductCode not populated. Please make sure you have selected the correct product" });
            return;
        }
   
        this.state.loading = true;
        fetch(`api/Transfer/GetStockOnHand?namecode=${this.state.namecode}&sku=${this.state.productCode}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to load SOH!! " + errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ soh: data });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load SOH!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load SOH!!" });
                    }

                }

            })
            .catch(error => {
                this.setState({ soh: [], alertMessage: error, loading: false });
            });
    }
    renderStockOnHand() {

        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Location</th>
                        <th>Units</th>
                        <th>Commited</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.soh.map((row, index) =>
                        <tr key={index} >
                            <td>{row.location}</td>
                            <td>{row.units}</td>
                            <td>{row.commited}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }


    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let stockOnHandHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderStockOnHand();

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Stock On Hand</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.props.history.goBack(); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col >
                            <label className="large">Code : {this.state.productCode}</label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {stockOnHandHtml}
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>
        );
    }
}
